export default "__VITE_ASSET__bwfd4xSK__"